// Notification helpers using the browser Notification API + scheduling via setTimeout
// Works on phone when added to home screen / PWA and notification permission granted.

export async function requestNotificationPermission() {
  if (typeof window === "undefined" || !("Notification" in window)) return "unsupported";
  if (Notification.permission === "granted") return "granted";
  if (Notification.permission === "denied") return "denied";
  try {
    return await Notification.requestPermission();
  } catch {
    return "denied";
  }
}

export function notifySupported() {
  return typeof window !== "undefined" && "Notification" in window;
}

export function showNotification(title, body) {
  if (!notifySupported()) return;
  if (Notification.permission !== "granted") return;
  try {
    new Notification(title, { body, icon: "/favicon.ico" });
  } catch {}
}

const scheduledTimers = new Map(); // eventId -> timeoutId

export function clearScheduledNotifications() {
  for (const t of scheduledTimers.values()) clearTimeout(t);
  scheduledTimers.clear();
}

export function scheduleEventNotifications(events) {
  clearScheduledNotifications();
  if (!notifySupported() || Notification.permission !== "granted") return;
  const now = Date.now();
  for (const ev of events) {
    if (ev.reminder_minutes_before == null || !ev.time) continue;
    const [h, m] = ev.time.split(":").map(Number);
    const [Y, M, D] = ev.date.split("-").map(Number);
    const target = new Date(Y, M - 1, D, h, m, 0, 0).getTime();
    const fireAt = target - ev.reminder_minutes_before * 60 * 1000;
    if (fireAt <= now) continue;
    const delay = Math.min(fireAt - now, 2_147_483_000); // max setTimeout
    const id = setTimeout(() => {
      showNotification(
        `Upcoming: ${ev.title}`,
        `${ev.time}${ev.description ? " — " + ev.description : ""}`
      );
    }, delay);
    scheduledTimers.set(ev.id, id);
  }
}
